export enum RouteEnum {
  DELAER_BASE_LOGIN_URL = 'dealer/login',
  DELAER_MEETING_BASE_ROUTE_PATH = '/dealer/meeting',
  DEALER_ENQ_BASE_ROUTE_PATH = '/dealer/enquiry',
  DELAER_MEETING_DETAILS_ROUTE_PATH = `${DELAER_MEETING_BASE_ROUTE_PATH}/details`,
  DELAER_ENQ_DETAILS_ROUTE_PATH = `${DEALER_ENQ_BASE_ROUTE_PATH}/details`,
}
